module.exports = __webpack_public_path__ + "img/5351.a9164d05.jpg";